<template>
  <div class="searchlinLongAssessPage">
    <div class="searchTit clearfix">
      <a href="javascript:void(0);" class="fl" @click="goBack">
        <van-icon name="arrow-left" />
      </a>
      <p>{{$t('searchMsg.linLongAssessTit')}}</p>
    </div>
    <van-tabs v-model="activeName">
      <van-tab :title="$t('common.evaluateTit')" name="assess">
        <search-assess :selcetType="selcetType"></search-assess>
      </van-tab>
      <van-tab :title="$t('common.commentTit')" name="comment">
        <search-comment :selcetType="selcetType"></search-comment>
      </van-tab>
    </van-tabs>
    <!--  -->
  </div>
</template>
<script>
/*eslint-disable*/
// import { getToken } from "@/utils/common";
const searchAssess = () => import("@/views/search/child/searchAssess");
const searchComment = () => import("@/views/search/child/searchComment");
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "searchlinLongAssess",
  data() {
    return {
      activeName: "assess",
      selcetType: "linForest",
      clientType: "" //手机类型
    };
  },
  mounted() {
    this.clientType = getDeviceType();
  },
  components: {
    searchAssess,
    searchComment
  },
  methods: {
    goBack() {
      let _this = this;
      _this.$emit("changeType", true);
        this.$store.commit("SetcloseShowType", "open");
    }
  }
};
</script>
<style lang="less"  >
.searchlinLongAssessPage {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;

  .searchTit {
    width: 100%;
    padding: 0 16px;
    height: 35px;
    background-color: #fff;
    position: relative;

    a {
      display: inline-block;
      width: 55px;
      padding-left: 15px;
      line-height: 35px;
      font-size: 14px;
      color: #4bc08a;
      position: relative;

      .van-icon {
        position: absolute;
        left: 0;
        top: 11px;
        display: inline-block;
        font-size: 14px;
        color: #4bc08a;
        font-weight: 600;
      }
    }

    p {
      width: 200px;
      line-height: 35px;
      margin: 0 auto;
      color: #666;
      text-align: center;
      font-size: 14px;
    }
  }
  .van-tabs {
    height: 87%;
    box-sizing: border-box;

    .van-tab--active.van-tab {
      .van-tab__text {
        color: #4bc08a;
      }
    }
    .van-tabs__line {
      background-color: #0aba8c;
    }
    .van-tabs__content {
      height: 93%;
      overflow: hidden;
      .van-tab__pane {
        height: 100%;
         
      }
    }
  }
}
</style>